import React from 'react';
import SvgIcon from 'e100-react-components/lib/components/SvgIcon';
import { IProps } from 'e100-react-components/lib/components/SvgIcon/index';

export const Share = (props: IProps) => (
  <SvgIcon {...props}>
    <path d="M13.334 3.33333L12.1507 4.51667L10.8257 3.19167V12.5H9.17565V3.19167L7.85065 4.51667L6.66732 3.33333L10.0007 0L13.334 3.33333ZM16.6673 7.5V16.6667C16.6673 17.5833 15.9173 18.3333 15.0007 18.3333H5.00065C4.07565 18.3333 3.33398 17.5833 3.33398 16.6667V7.5C3.33398 6.575 4.07565 5.83333 5.00065 5.83333H7.50065V7.5H5.00065V16.6667H15.0007V7.5H12.5007V5.83333H15.0007C15.9173 5.83333 16.6673 6.575 16.6673 7.5Z" />
  </SvgIcon>
);
